import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../../../../../services/login.service';
import { Router } from '@angular/router';
import { CtaAction } from '../../../../../../models/cta.action';
import { User } from '../../../../../../models/user.model';

@Component({
  selector: 'jhi-impersonate-list',
  templateUrl: './impersonate-list.component.html',
})
export class ImpersonateListComponent {
  readonly #router = inject(Router);
  readonly #translateService = inject(TranslateService);
  readonly #loginService = inject(LoginService);

  @Input() public users: User[] = [];
  @Input() public tableOptions?: TableOptions;
  @Input() public pagination!: Pagination;
  @Output() public paginationChange = new EventEmitter<Pagination>();
  public PATHS = PATHS;
  public ctaActions: CtaAction[] = [
    {
      label: this.#translateService.instant('impersonate.ctaLabel'),
      action: 'IMPERSONATE',
      tooltip: this.#translateService.instant('impersonate.ctaTooltip'),
      dataIdCypress: 'span-se-connecter',
    },
  ];

  public onSelectAction(user: User): void {
    this.#loginService
      .loginImpersonate({
        username: user.login!,
        password: 'jglskdgjlgkjdlk', // il faut absolument une valeur (fake)
        rememberMe: true,
      })
      .subscribe(() => {
        if (!this.#router.getCurrentNavigation()) {
          this.#router.navigate(['/']).then(() => {
            window.location.reload();
          });
        }
      });
  }

  public trackId(index: number, item: User): number {
    return item.id!;
  }

  public transition(): void {
    this.paginationChange.emit(this.pagination);
  }
}
